import { Box, IconButton, Typography } from "@mui/material";
import moment from "moment-timezone";
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import NavigationRefresh from "@mui/icons-material/Refresh";
import { useQuery } from "@tanstack/react-query";
import { apiRoutes, fetchJson } from "@/src/services";
import { buildQueryUrl } from "@/src/utils";

interface Record {
    _id: string,
    count: number
}

interface Props {
    timezone: string,
    days?: number
}

export const ActiveUsers = ({ timezone, days = 30 }: Props) => {

    const { data, refetch } = useQuery<Record[]>({
        queryKey: ['active-day-by-day', days, timezone],
        queryFn: () => fetchJson(buildQueryUrl(apiRoutes.dashboard.activeByDate2, { days, timezone }))
            .then(resp => {
                return resp.json
            }),

        staleTime: Infinity,
        refetchOnWindowFocus: false,
        select: records => records.map((r => ({ ...{ count: 0 }, ...r })))
    });

    return (
        <Box>
            <IconButton onClick={() => refetch()} aria-label="refresh" color="primary"><NavigationRefresh /></IconButton>
            <Typography variant="h6" align="center">Active Unique</Typography>
            <ResponsiveContainer width="100%" height={220}>
                <LineChart data={data} margin={{ top: 20, right: 10, left: -20, bottom: 0 }}>
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="_id"
                        tick={{ fontSize: 12 }}
                        tickFormatter={(value) => (!value || value === "auto") ? value : moment(value).tz(timezone).format('D MMM')}
                    />
                    <YAxis tick={{ fontSize: 12 }} />
                    <Tooltip
                        labelFormatter={(value: any) => moment(value).tz(timezone).format('D MMM')}
                    />
                    <Legend />
                    <Line dataKey="count" />
                </LineChart>
            </ResponsiveContainer>
        </Box>
    )



}